<template>
  <div>
    <dialogos-app :dialogos="dialogos" :personaje="false"></dialogos-app>
    <v-layout class="wrap-md-and-down" align-center="">
      <v-flex class="flex-img">
        <img src="../../assets/presentacion/diapositiva-2.png" alt="instructor">
      </v-flex>
      <v-flex xs12 pl-4>
        <router-link to="/modulo3/0" class="modulo"><span class="wrapper wrapper-3"><span class="numero_modulo">M3</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 3:</span> Métodos de estimación</span></router-link>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 17',
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "¡Felicitaciones! Has finalizado el módulo con éxito. Te invito a continuar el siguiente. <span class='instruccion'>Haz clic en el icono.</span>" 
      ],
      preguntas: []
    }
  },
  created() {
    this.$store.commit('nextShow', false)
    this.preguntas = require('../../assets/Modulo 1/diapositiva-14.json');
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/moduleButtons';
</style>
